import { type MutableRefObject } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { AppCapability, isCapable } from '@/utils/capabilities';

/**
 * Custom hook that registers an 'Escape' key handler to blur an input or textarea element.
 * @param inputRef Reference to the input or textarea element to blur
 * @returns A ref object to be merged with the target element's ref
 */

export function useRegisterBlurInputHotkey(
  inputRef: MutableRefObject<HTMLElement | undefined>
) {
  return useHotkeys(
    'esc',
    () => {
      if (!isCapable(AppCapability.HotKeys)) return;

      const inputElement = inputRef.current;

      if (!inputElement) return;

      inputElement.blur();
    },
    {
      preventDefault: true,
      enableOnContentEditable: true,
      enableOnFormTags: true,
    }
  );
}
